import LoginApi from "../services/loginApi";
import { AuthFormTypes, ResponseAuthTypes } from "types/auth";

export async function LoginAuth(
  parms: AuthFormTypes
): Promise<ResponseAuthTypes> {
  const response = await LoginApi.post("/login", parms);

  return response.data;
}
